









import { Vue, Prop, Component } from "vue-property-decorator";

@Component({})
export default class FileItem extends Vue {
  @Prop({ type: String, default: "" }) fileName!: string;
  @Prop({ type: String, default: "" }) fileUrl!: string;

  onClickFile() {
    this.$emit("onClickFile", this.fileUrl);
  }

  get isPdfFile(): boolean {
    const splittedFileName = this.fileName.split(".");
    if (splittedFileName[splittedFileName.length - 1] === "pdf") return true;
    return false;
  }
}
